import { render, staticRenderFns } from "./SessionItemIcon.vue?vue&type=template&id=64e1dcdf&"
import script from "./SessionItemIcon.vue?vue&type=script&lang=js&"
export * from "./SessionItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports